import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  ThemeProvider,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CustomSelect from "../../../../../../Components/CustomSelect";
import DataService from "../../../../../../Service";
import FeedbackModal from "../../../../Admin/Reports/Feedback/acuity/FeedbackModal";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FileDownloadIcon from "@material-ui/icons/ArrowDownward";
import { useDispatch } from "react-redux";
import { deleteFeedback } from "./store/FeedbackService";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import AlertDialog from "../../../../../../Components/CustomDialog";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { fontTheme } from "../../../../../../fontTheme";
import { utils, writeFile, write } from "xlsx";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoImage from "../../../../../../Images/acuity-logo.png";
import clientLogoDemo from "../../../../../../Images/demo_client_new_logo.png";
import moment from "moment";
import useDownloads from "../../useDownloads";
const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    margin: "0 auto",
  },
  customTextField: {
    "& div": {
      padding: "0px !important",
      height: "47px",
    },
  },
}));

const sortByArray = [
  { id: 1, name: "All", value: "All" },
  { id: 2, name: "Most recent", value: "Most recent" },
  { id: 2, name: "Last 6 months", value: "Last 6 months" },
  { id: 2, name: "Last year", value: "Last year" },
];
function Acuity(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [orgData, setOrgData] = useState([]);
  const [acuityFeedback, setAcuityFeedback] = useState([]);
  const [modal, setModal] = useState(false);
  const [currentSelection, setCurrentSelection] = useState(undefined);
  const [dialogState, setDialogState] = useState(undefined);
  //
  const [orgValue, setOrgValue] = useState("");
  const [sortValue, setSortValue] = useState(sortByArray[0].value);

  const [inputValue, setInputValue] = useState("");
  const [userData, setUserData] = useState({
    organisation_id: orgValue.id,
    sort_by: sortValue,
  });

  const getData = () => {
    return DataService.getData(userData, "acuityFeedback");
  };

  console.log(userData, "user data");

  const fileName =
    orgData.length > 0 && orgValue !== ""
      ? orgData?.find((el) => el.id === userData.organisation_id)
          ?.organisation_name + "_Acuity Feedback"
      : "Acuity Feedback";
  const columns = [
    { field: "organisation_name", title: "Organization" },
    { field: "given_by", title: "Given by" },
    { field: "feedback", title: "Feedback" },
  ];
  const role = sessionStorage.getItem("role");
  const { downloading, downloadingOption, exportPDF, exportCsv, exportXLSX } =
    useDownloads({
      columns,
      getData,
      listKey: "acuity_feedbacks",
      userData: {
        organisation: userData.organisation_id,
      },
      role,
      fileName,
    });

  //
  const onChangeItem = (selectedItemValue) => {
    setSortValue(selectedItemValue.value);
    setUserData((prev) => ({ ...prev, sort_by: selectedItemValue.value }));
  };

  useEffect(() => {
    getAcuityFeedback(userData);
  }, [userData]);

  useEffect(() => {
    DataService.getData({}, "organisations").then((res) => {
      var localArr = [
        {
          id: null,
          org_id: null,
          organisation_name: "All",
          internal_status: "All",
        },
        ...res.organisations,
      ];
      setOrgData(orgData.concat(localArr));
    });
  }, []);

  const getAcuityFeedback = (userData) => {
    DataService.getData(userData, "acuityFeedback").then((res) => {
      setAcuityFeedback(res?.acuity_feedbacks || []);
    });
  };

  const onCreate = () => {
    getAcuityFeedback();
    setCurrentSelection(undefined);
  };

  const handleDeleteFeedback = (id) => {
    dispatch(deleteFeedback(id, onCreate));
  };

  const downloadXls = () => {
    DataService.getData({ ...userData, csv: true }, "acuityFeedback")
      .then((res) => {
        window.location.assign(res.file);
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"]));
      });
  };

  return (
    <Box py={3}>
      <ThemeProvider theme={fontTheme}>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Grid container direction="row" spacing={1}>
              <Grid item xs={3}>
                <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                  <Box mb={1}>Select organization</Box>
                </Typography>
                <Autocomplete
                  value={orgValue}
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      newValue = "";
                    }

                    setOrgValue(newValue);
                    setUserData((prev) => ({
                      ...prev,
                      organisation_id: newValue.id,
                    }));
                  }}
                  classes={{
                    input: classes.autoComplete,
                    option: classes.autoComplete,
                  }}
                  inputValue={inputValue}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  id="controllable-states-demo"
                  options={orgData}
                  getOptionLabel={(option) => option.organisation_name}
                  // style={{ width: 280 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.customTextField}
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: "16px", fontFamily: "Open sans" },
                      }}
                      placeholder="Organization name"
                      style={{ fontSize: "20px", height: "15px" }}
                      autoFocus
                      variant="outlined"
                    />
                  )}
                />
                {/* <CustomSelect id="organisation" labelText="Organization" displayEmpty variant="outlined" itemArr={['All', ...orgData.map((option) => option.organisation_name)]} parentcall={onChangeItem} defaultValue={userData.organisation} /> */}
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                  <Box mb={1}>Sort by</Box>
                </Typography>
                <CustomSelect
                  id="sortBy"
                  labelText="Most recent"
                  displayEmpty
                  variant="outlined"
                  itemArr={sortByArray.map((value) => value.value)}
                  parentcall={onChangeItem}
                  value={sortValue}
                  defaultValue={sortValue}
                />
              </Grid>
              <Grid item xs={6}>
                <Box
                  textAlign="right"
                  display={"flex"}
                  alignItems={"flex-end"}
                  justifyContent={"flex-end"}
                  height={"100%"}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      height: "100%",
                      alignSelf: "flex-end",
                    }}
                  >
                    <Button
                      color="primary"
                      disabled={!acuityFeedback?.length}
                      style={{
                        textTransform: "inherit",
                        float: "right",
                        marginTop: "18px",
                        width: "80px",
                      }}
                      variant="contained"
                      onClick={exportXLSX}
                    >
                      {downloading && downloadingOption === "xlsx" ? (
                        <CircularProgress
                          size={22}
                          style={{ marginRight: "5px", color: "white" }}
                        />
                      ) : (
                        <SaveAltIcon style={{ marginRight: "5px" }} />
                      )}
                      .xlsx
                    </Button>

                    <Button
                      color="primary"
                      disabled={!acuityFeedback?.length}
                      style={{
                        textTransform: "inherit",
                        float: "right",
                        marginTop: "18px",
                        width: "80px",
                      }}
                      variant="contained"
                      onClick={exportCsv}
                    >
                      {downloading && downloadingOption === "csv" ? (
                        <CircularProgress
                          size={22}
                          style={{ marginRight: "5px", color: "white" }}
                        />
                      ) : (
                        <SaveAltIcon style={{ marginRight: "5px" }} />
                      )}{" "}
                      .csv
                    </Button>

                    <Button
                      color="primary"
                      disabled={!acuityFeedback?.length}
                      style={{
                        textTransform: "inherit",
                        float: "right",
                        marginTop: "18px",
                        width: "80px",
                      }}
                      variant="contained"
                      onClick={exportPDF}
                    >
                      {downloading && downloadingOption === "pdf" ? (
                        <CircularProgress
                          size={22}
                          style={{ marginRight: "5px", color: "white" }}
                        />
                      ) : (
                        <SaveAltIcon style={{ marginRight: "5px" }} />
                      )}{" "}
                      .pdf
                    </Button>
                  </div>

                  <Button
                    variant="contained"
                    color="secondary"
                    style={{
                      textTransform: "inherit",
                      float: "right",
                      marginTop: "18px",
                      marginLeft: "10px",
                    }}
                    onClick={() => {
                      setModal(true);
                    }}
                  >
                    Add feedback
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box mt={4}>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                marginTop: 20,
                borderWidth: 1,
                borderColor: "#ddd",
                borderStyle: "solid",
                padding: 16,
              }}
            >
              <Grid item xs={3}>
                <Typography variant="h2">
                  <Box fontWeight="fontWeightBold" color={"#077F83"}>
                    Organization
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="h2">
                  <Box fontWeight="fontWeightBold" color={"#077F83"}>
                    Given by
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="h2">
                  <Box fontWeight="fontWeightBold" color={"#077F83"}>
                    Feedback
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="h2">
                  <Box fontWeight="fontWeightBold" color={"#077F83"}>
                    Action
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Box>
              {acuityFeedback?.length ? (
                acuityFeedback?.map((option, index) => {
                  return (
                    <>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{
                          borderWidth: 1,
                          borderColor: "#ddd",
                          borderStyle: "solid",
                          padding: 16,
                        }}
                      >
                        <Grid item xs={3} style={{ paddingInline: 5 }}>
                          <Typography variant="h2" style={{ color: "#320032" }}>
                            <Box>{option?.organisation_name || "-"}</Box>
                          </Typography>
                        </Grid>
                        <Grid item xs={3} style={{ paddingInline: 5 }}>
                          <Typography variant="h2" style={{ color: "#320032" }}>
                            <Box>{option?.given_by || "-"}</Box>
                          </Typography>
                        </Grid>
                        <Grid item xs={5} style={{ paddingInline: 5 }}>
                          <Typography variant="h2" style={{ color: "#320032" }}>
                            <Box>{option?.feedback || "-"}</Box>
                          </Typography>
                          `{" "}
                        </Grid>
                        <Grid
                          item
                          xs={1}
                          style={{ paddingInline: 5, display: "flex" }}
                        >
                          <EditIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setCurrentSelection(option);
                              setModal(true);
                            }}
                          />
                          <DeleteIcon
                            onClick={() =>
                              setDialogState({
                                isOpen: true,
                                index: option?.id,
                              })
                            }
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                          />
                        </Grid>
                      </Grid>
                      <Divider />
                    </>
                  );
                })
              ) : (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{
                    borderWidth: 1,
                    borderColor: "#ddd",
                    borderStyle: "solid",
                    padding: 16,
                  }}
                >
                  <Grid item xs={3}>
                    <Typography variant="h2" style={{ color: "#232323" }}>
                      <Box>{"Record not found"}</Box>
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>
        </Box>
        {modal ? (
          <FeedbackModal
            {...props}
            orgData={orgData}
            currentSelection={currentSelection}
            onCreate={onCreate}
            pageData={props?.pageData}
            isOpen={modal}
            onClose={() => {
              setModal(false);
              setCurrentSelection(undefined);
            }}
          />
        ) : null}

        {dialogState?.isOpen && (
          <AlertDialog
            dialogState={dialogState}
            dialogContent={`Are you sure you want to delete this feedback?`}
            handleSubmit={(value) => handleDeleteFeedback(value.index)}
            handleClose={() => setDialogState(undefined)}
          />
        )}
      </ThemeProvider>
    </Box>
  );
}

export default Acuity;
